export default __webpack_public_path__ + "static/media/question-icon.1612641a.svg";